export const isPx = (arg: string): arg is `${number}px` => arg.endsWith("px");

export const isRem = (arg: string): arg is `${number}rem` =>
  arg.endsWith("rem");

export const pxOrRemToUnitlessPx = (arg: `${number}px` | `${number}rem`) => {
  if (isRem(arg)) {
    return parseFloat(arg.replace("rem", "")) * 16;
  }
  return parseFloat(arg.replace("px", ""));
};
